export const WAVEFORM_COLOR = '#ffffff'
export const WAVEFORM_LINE_WIDTH = 1.5
export const BAR_COUNT = 16
export const BAR_WIDTH = 4
export const BAR_GAP = 1
export const WAVEFORM_WIDTH = BAR_COUNT * (BAR_WIDTH + BAR_GAP)

export const drawFlatLine = (canvas: HTMLCanvasElement) => {
  const ctx = canvas.getContext('2d')
  if (!ctx) return
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.beginPath()
  ctx.strokeStyle = WAVEFORM_COLOR
  ctx.lineWidth = WAVEFORM_LINE_WIDTH
  ctx.moveTo(0, canvas.height / 2)
  ctx.lineTo(canvas.width, canvas.height / 2)
  ctx.stroke()
}
